/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";

import type { FC } from "react";

export const NormalButton: FC<{
  isDarkModeEnabled: boolean;
  type: "primary" | "secondary";
  label: string;
  onClick?: () => void;
}> = ({ isDarkModeEnabled, type, label, onClick }) => {
  const color =
    type === "primary"
      ? isDarkModeEnabled
        ? "#000"
        : "#fff"
      : isDarkModeEnabled
        ? "#fff"
        : "#000";
  const bgColor =
    type === "primary" ? (isDarkModeEnabled ? "#fff" : "#000") : "transparent";

  return (
    <button
      type={"button"}
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
        padding: 6px 12px;
        text-align: center;
        background-color: ${bgColor};
        border: 1px solid ${isDarkModeEnabled ? "#fff" : "#000"};
        border-radius: 6px;
        cursor: pointer;
      `}
      onClick={onClick}
    >
      <Box
        component={"span"}
        color={color}
        fontSize={"14px"}
        fontWeight={"700"}
      >
        {label}
      </Box>
    </button>
  );
};
